export const INVALID_FORM_INPUT = `Invalid or incomplete form`;

export const INVALID_VIDEO_URL = `Invalid Video URL`;

export const INPUT_VALID_VIDEO_URL = `Input a valid video URL to see the preview`;
